
import { defineComponent } from "vue";

export default defineComponent({
  name: "SidebarLeft",
  props: {
    showElem: { type: Function },
    isToolbarHidden: { type: String },
    isSidebarToolbarHidden: {},
    slotProps: {},
  },
});
